export default {
	comum: {
		rota: {
			origem: 'Inicial',
		},
		requisicoesPendentes: 0,
		executarSemLoading: false,
		loadingManual: false,
	},
	cabecalhoPadrao: [
		{
			titulo: '',
			subtitulo: {
				texto: '',
			},
		},
	],
	isPodeAderir: false,
	casasDecimais: {
		numeroCasasDecimaisQtde: null,
		numeroCasasDecimaisValores: null,
	},
	campoArquivoNovo: {
		arquivoTemporario: null,
		erroObrigatoriedade: false,
		documentoComAnexo: null,
		documentoSelecionado: null,
	},
	campoEditarNumero: {
		numero: null,
	},
	defaultLoadingMessage: 'Carregando...',
	modalAssinaturaFlowbee: {
		exibir: false,
		documentosSelecionados: [],
	},
	escolherOrgao: {
		modal: {
			exibir: false,
		},
	},
	orgaoLogado: 0,
}
